var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("EnviaCorreoIndividual"),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "pa-0 m-0" },
        [
          _c(
            "v-btn",
            {
              staticClass: "py-0 px-2 m-0",
              attrs: {
                color: "#0085AD",
                loading: _vm.loading,
                dark: "",
                block: "",
                title: "Notificar papeletas no presentadas"
              },
              on: {
                click: function($event) {
                  return _vm.abrirCerrarDialog()
                }
              }
            },
            [
              _c("v-icon", [_vm._v("mail")]),
              _vm._v("\n      NOTIFICACIONES\n    ")
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.cargarPapeletasNoPresentadas(_vm.form)
                    }
                  },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "headline" },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs9: "" } },
                        [
                          _c("v-icon", [_vm._v("mail")]),
                          _vm._v(
                            " NOTIFICACIÓN PAPELETAS NO ENTREGADAS\n          "
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.abrirCerrarDialog()
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "px-3" },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "px-1",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  label: "Fecha inicio",
                                  type: "date",
                                  outline: "",
                                  clearable: "",
                                  success: ""
                                },
                                model: {
                                  value: _vm.form.fecha_inicio,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_inicio", $$v)
                                  },
                                  expression: "form.fecha_inicio"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "px-1",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  label: "Fecha fin",
                                  type: "date",
                                  outline: "",
                                  clearable: "",
                                  success: ""
                                },
                                model: {
                                  value: _vm.form.fecha_fin,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_fin", $$v)
                                  },
                                  expression: "form.fecha_fin"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "p-0 m-0",
                                  attrs: {
                                    color: "#0085AD",
                                    loading: _vm.loading,
                                    dark: "",
                                    block: "",
                                    title: "Notificar faltas",
                                    type: "submit"
                                  }
                                },
                                [
                                  _c("v-icon", [_vm._v("search")]),
                                  _vm._v(
                                    "\n                BUSCAR\n              "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { staticClass: "pb-2", attrs: { xs12: "" } },
                            [
                              _c("CalendarioNotificaciones", {
                                key: _vm.key_historial
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.fecha_inicio_consulta && _vm.fecha_fin_consulta
                            ? _c(
                                "v-flex",
                                {
                                  staticClass:
                                    "text-xs-center blue--text title",
                                  attrs: { xs12: "" }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm
                                          .$moment(_vm.fecha_inicio_consulta)
                                          .format("DD/MM/YYYY")
                                      ) +
                                      " -\n              " +
                                      _vm._s(
                                        _vm
                                          .$moment(_vm.fecha_fin_consulta)
                                          .format("DD/MM/YYYY")
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pb-1 layout wrap",
                              attrs: { xs12: "" }
                            },
                            [
                              _vm.selected.length < _vm.l_papeletas.length
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "#0085AD",
                                        loading: _vm.loading,
                                        dark: "",
                                        title: "Seleccionar todo"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.seleccionarDeseleccionarTodo(
                                            _vm.l_papeletas,
                                            true
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", [_vm._v("check")]),
                                      _vm._v(
                                        "\n                Seleccionar todo\n              "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selected.length > 0
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "red",
                                        loading: _vm.loading,
                                        dark: "",
                                        title: "Deseleccionar todo"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.seleccionarDeseleccionarTodo(
                                            _vm.l_papeletas,
                                            false
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", [_vm._v("close")]),
                                      _vm._v(
                                        "\n                Deseleccionar todo\n              "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selected.length > 0
                                ? _c("EnviaCorreoMasivo", {
                                    attrs: {
                                      lista_correos: _vm.selected,
                                      parametros_notificacion: {
                                        fecha_inicio: this.form.fecha_inicio,
                                        fecha_fin: this.form.fecha_fin,
                                        faltas: _vm.l_sanciones
                                          .filter(function(sancion) {
                                            return sancion.check
                                          })
                                          .map(function(sancion) {
                                            return sancion.descripcion
                                          })
                                          .join(";")
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-data-table", {
                                staticClass:
                                  "elevation-1 tabla-comprimida-light",
                                attrs: {
                                  headers: _vm.headers,
                                  items: _vm.l_papeletas,
                                  "no-data-text": _vm.loading
                                    ? "Cargando..."
                                    : "No se tiene registros",
                                  loading: _vm.loading,
                                  "item-key": "index",
                                  "rows-per-page-text": "Filas por pagina",
                                  pagination: _vm.pagination,
                                  "rows-per-page-items": [5, 10, 20, 50]
                                },
                                on: {
                                  "update:pagination": function($event) {
                                    _vm.pagination = $event
                                  }
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "headers",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "tr",
                                          _vm._l(props.headers, function(
                                            header
                                          ) {
                                            return _c(
                                              "th",
                                              {
                                                key: header.text,
                                                class: [
                                                  "column sortable",
                                                  _vm.pagination.descending
                                                    ? "desc"
                                                    : "asc",
                                                  header.value ===
                                                  _vm.pagination.sortBy
                                                    ? "active"
                                                    : ""
                                                ],
                                                on: {
                                                  click: function($event) {
                                                    return _vm.changeSort(
                                                      header.value
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                header.value
                                                  ? _c(
                                                      "v-icon",
                                                      { attrs: { small: "" } },
                                                      [_vm._v("arrow_upward")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(header.text) +
                                                    "\n                    "
                                                )
                                              ],
                                              1
                                            )
                                          }),
                                          0
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "items",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "td",
                                          [
                                            _c("v-checkbox", {
                                              attrs: {
                                                primary: "",
                                                "hide-details": ""
                                              },
                                              model: {
                                                value: props.item.check,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    props.item,
                                                    "check",
                                                    $$v
                                                  )
                                                },
                                                expression: "props.item.check"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(props.item.nombres) +
                                              "\n                  "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(props.item.correo) +
                                              "\n                  "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          [
                                            _c(
                                              "v-expansion-panel",
                                              [
                                                _c(
                                                  "v-expansion-panel-content",
                                                  {
                                                    staticClass:
                                                      "panel-reducido",
                                                    staticStyle: {
                                                      background:
                                                        "rgb(180, 218, 233)"
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "actions",
                                                          fn: function() {
                                                            return [
                                                              _c("v-icon", [
                                                                _vm._v(
                                                                  "$vuetify.icons.expand"
                                                                )
                                                              ])
                                                            ]
                                                          },
                                                          proxy: true
                                                        },
                                                        {
                                                          key: "header",
                                                          fn: function() {
                                                            return [
                                                              _c("div", [
                                                                _vm._v(
                                                                  "VER DETALLE"
                                                                )
                                                              ])
                                                            ]
                                                          },
                                                          proxy: true
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-card",
                                                      [
                                                        _c("v-divider"),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-card-text",
                                                          {
                                                            staticClass: "pt-0"
                                                          },
                                                          [
                                                            props.item
                                                              .loading != true
                                                              ? _c(
                                                                  "v-layout",
                                                                  {
                                                                    attrs: {
                                                                      "align-center":
                                                                        "",
                                                                      "justify-space-between":
                                                                        ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "table",
                                                                      {
                                                                        staticClass:
                                                                          "tabla-faltas"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "tr",
                                                                          [
                                                                            _c(
                                                                              "th",
                                                                              [
                                                                                _vm._v(
                                                                                  "Nro papeleta"
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "th",
                                                                              [
                                                                                _vm._v(
                                                                                  "Fecha desde"
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "th",
                                                                              [
                                                                                _vm._v(
                                                                                  "Fecha hasta"
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "th",
                                                                              [
                                                                                _vm._v(
                                                                                  "Dias"
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "th",
                                                                              [
                                                                                _vm._v(
                                                                                  "Tipo"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _vm._l(
                                                                          props
                                                                            .item
                                                                            .papeletas,
                                                                          function(
                                                                            papeleta,
                                                                            index
                                                                          ) {
                                                                            return _c(
                                                                              "tr",
                                                                              {
                                                                                key: index
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "td",
                                                                                  {
                                                                                    staticStyle: {
                                                                                      width:
                                                                                        "25%"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                    " +
                                                                                        _vm._s(
                                                                                          papeleta.secuencia
                                                                                        ) +
                                                                                        "\n                                  "
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "td",
                                                                                  {
                                                                                    staticStyle: {
                                                                                      width:
                                                                                        "25%"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                    " +
                                                                                        _vm._s(
                                                                                          _vm
                                                                                            .$moment(
                                                                                              papeleta.fecha_desde
                                                                                            )
                                                                                            .format(
                                                                                              "DD/MM/YYYY"
                                                                                            )
                                                                                        ) +
                                                                                        "\n                                  "
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "td",
                                                                                  {
                                                                                    staticStyle: {
                                                                                      width:
                                                                                        "25%"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                    " +
                                                                                        _vm._s(
                                                                                          _vm
                                                                                            .$moment(
                                                                                              papeleta.fecha_hasta
                                                                                            )
                                                                                            .format(
                                                                                              "DD/MM/YYYY"
                                                                                            )
                                                                                        ) +
                                                                                        "\n                                  "
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "td",
                                                                                  {
                                                                                    staticStyle: {
                                                                                      width:
                                                                                        "25%"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                    " +
                                                                                        _vm._s(
                                                                                          papeleta.total_dias
                                                                                        ) +
                                                                                        "\n                                  "
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "td",
                                                                                  {
                                                                                    staticStyle: {
                                                                                      width:
                                                                                        "25%"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                    " +
                                                                                        _vm._s(
                                                                                          papeleta.tipo_vacacion
                                                                                        ) +
                                                                                        "\n                                  "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          }
                                                                        )
                                                                      ],
                                                                      2
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "p-0 m-0",
                                                attrs: {
                                                  color: "#0085AD",
                                                  loading: _vm.loading,
                                                  dark: "",
                                                  title: "Notificar correo",
                                                  icon: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.notificacionIndividual(
                                                      props.item
                                                    )
                                                  }
                                                }
                                              },
                                              [_c("v-icon", [_vm._v("mail")])],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b19e7c02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b19e7c02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_rrhh/components/NotificacionPapeletasNoPresentadas.vue
// module id = null
// module chunks = 